// extracted by mini-css-extract-plugin
export default {"goods":"Goods_goods__zH+uN","column":"Goods_column__It47U"};